/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Filter(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg xmlns='http://www.w3.org/2000/svg'>
                <g>
                    <g
                        display='none'
                        height='100%'
                        id='canvasGrid'
                        overflow='visible'
                        width='100%'
                        x='0'
                        y='0'
                    />
                </g>
                <g>
                    <g
                        fill={iconColor || '#000'}
                        id='svg_5'
                        stroke='null'
                    >
                        <path
                            d='m9.437879,22.358254l5.138453,0l0,-3.535261l-5.138453,0l0,3.535261zm-8.992533,-21.208914l0,3.535261l23.124483,0l0,-3.535261l-23.124483,0zm3.85408,12.371425l15.416322,0l0,-3.535261l-15.416322,0l0,3.535261z'
                            id='svg_4'
                            stroke='null'
                        />
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}